import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import ExpenseCategoriesFilters from 'src/components/ExpenseCategoriesFilters/ExpenseCategoriesFilters'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface ExpenseCategoryLabelsFilterProps {
  expenseCategories: any[] | undefined
  expenseCategoriesSet: Record<string, Set<string>>
  handleExpenseCategoriesSelection: (
    categoryId: string,
    labelSet: Set<string>,
  ) => void
}

const ExpenseCategoryLabelsFilter: React.FC<
  ExpenseCategoryLabelsFilterProps
> = ({
  expenseCategories,
  expenseCategoriesSet,
  handleExpenseCategoriesSelection,
}) => {
  const translate = useTranslate()

  return (
    <>
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
          margin-bottom: 20px;
        `}
      >
        {translate('Expense Categories')}
      </div>
      <ExpenseCategoriesFilters
        expenseDetails={expenseCategoriesSet}
        onExpenseCategoryChange={(
          categoryId: string,
          labelId: string,
        ): void => {
          const newSelectedLabels = new Set(expenseCategoriesSet[categoryId])
          if (newSelectedLabels.has(labelId)) {
            newSelectedLabels.delete(labelId)
          } else {
            newSelectedLabels.add(labelId)
          }
          handleExpenseCategoriesSelection(categoryId, newSelectedLabels)
        }}
        onResetClick={(expCatId: string): void => {
          handleExpenseCategoriesSelection(expCatId, new Set())
        }}
      />
    </>
  )
}

export default ExpenseCategoryLabelsFilter
